// extracted by mini-css-extract-plugin
export default {"box":"Qlw9y4xgW_IIsfYJPpyg","filterRow":"no5jv2CocBFzm3QAd23r","formBox":"vMKifo9_KKxqrSrUPOnV"};